module.exports = __webpack_public_path__ + "assets/img/1.b91c7fc3.png";